<template lang="pug">
  .root
    the-heading(:caption="'Анализ данных пациента'")
    .container
      .main_block
        .caption.globalCaptionStyles Анализ данных пациента
        .header_text Общие данные
        .item_block
          .item
            span Дата рождения *
            .datepicker
              flat-pickr(v-mask="'##.##.####'" title="При ручном вводе данные нужно вводить только через точку" :config="dateConfig" v-model="birthdate" data-input placeholder="дд.мм.гггг"  @blur="onBlurBirthDate" autofocus)
              button.open(data-toggle :tabindex="-1")
                v-icon.i(name="calendar-alt" )
              button.clear(data-clear :tabindex="-1") ✖
              .error(v-if="errors.birthdate") {{errors.birthdate}}
          .item
            span Пол
            .radioBtn
              measure-radio-button(:options="genderData" :defaultValue="gender" v-model.number="gender")
          .item
            span Рост
            measure-input( :name="'Рост'" :error="errors.medData.height" :defaultValue="medData.height" :measure="'см'" :min="40" :max="255" :step="0.01" v-model.number="medData.height" )
          .item
            span Вес
            measure-input( :name="'Вес'" :error="errors.medData.weight" :defaultValue="medData.weight" :measure="'кг'" :min="0.5" :max="635" :step="0.01" v-model.number="medData.weight")
          .item
            span Окружность талии
            measure-input( :name="'Окружность талии'" :error="errors.medData.waistline" :defaultValue="medData.waistline" :measure="'см'" :min="0" :max="300" :step="0.01" v-model.number="medData.waistline" )
          .item
            span Температура тела
            measure-input( :name="'Температура тела'" :error="errors.medData.body_temperature" :defaultValue="medData.body_temperature" :measure="'°C'" :min="20" :max="43" :step="0.01" v-model.number="medData.body_temperature")
          .item
            span Артериальное давление
            InputAD(:name="'Артериальное давление'" :defaultValue1="medData.systolic_pressure" :defaultValue2="medData.diastolic_pressure")
          .item
            span ЧСС
            measure-input(v-mask="'###'" :name="'ЧСС'" :error="errors.medData.heart_rate" :defaultValue="medData.heart_rate" :measure="'уд. в мин.'" :min="10" :max="250" v-model.number="medData.heart_rate")
          .item
            span Частота дыхания
            measure-input(v-mask="'###'" :name="'Частота дыхания'" :error="errors.medData.breathing_rate" :defaultValue="medData.breathing_rate" :measure="'число/мин'" :min="1" :max="100" v-model.number="medData.breathing_rate")
          .item
            span Идентификатор пациента
            measure-input( :name="'Идентификатор пациента'" :min="0" :max="99999999" :defaultValue="patient_id" v-model.number="patient_id" )

        .header_text Лабораторные и инструментальные исследования
        .item_block
          .item
            span Общий холестерин
            measure-input( :name="'Общий холестерин'" :error="errors.medData.cholesterol" :defaultValue="medData.cholesterol" :measure="'ммоль/л'" :min="1" :max="40" :step="0.01" v-model.number="medData.cholesterol")
          .item
            span Липопротеиды высокой плотности
            measure-input( :error="errors.medData.hdl_cholesterol" :name="'Липопротеиды высокой плотности'" :defaultValue="medData.hdl_cholesterol" :measure="'ммоль/л'" :min="0.3" :max="5" :step="0.01" v-model.number="medData.hdl_cholesterol")
          .item
            span Креатинин крови
            measure-input(:name="'Креатинин крови'" :error="errors.medData.blood_creatinine" :defaultValue="medData.blood_creatinine" :measure="'мкмоль/л'" :min="10" :max="3000" :step="0.01" v-model.number="medData.blood_creatinine")
          .item
            span Креатинин в моче
            measure-input(:name="'Креатинин в моче'" :error="errors.medData.creatinine" :defaultValue="medData.creatinine" :measure="'г/л'" :min="0" :max="10" :step="0.01" v-model.number="medData.creatinine")
          .item
            span Липопротеиды низкой плотности
            measure-input( :name="'Липопротеиды низкой плотности'" :error="errors.medData.ldl_cholesterol" :defaultValue="medData.ldl_cholesterol" :measure="'ммоль/л'" :min="1" :max="20" :step="0.01" v-model.number="medData.ldl_cholesterol")
          .item
            span Триглицериды
            measure-input( :error="errors.medData.triglycerides" :name="'Триглицериды'" :defaultValue="medData.triglycerides" :measure="'ммоль/л'" :min="0" :max="30" :step="0.01" v-model.number="medData.triglycerides")
          .item
            span Азот мочевины крови
            measure-input( :name="'Азот мочевины крови'" :error="errors.medData.blood_urea_nitrogen" :defaultValue="medData.blood_urea_nitrogen" :measure="'ммоль/л'" :min="1" :max="120" :step="0.01" v-model.number="medData.blood_urea_nitrogen")
          .item
            span Глюкоза крови (любое измерение)
            measure-input( :error="errors.medData.glucose_level" :name="'Глюкоза крови (любое измерение)'" :defaultValue="medData.glucose_level" :measure="'ммоль/л'" :min="0" :max="50" :step="0.01" v-model.number="medData.glucose_level")
          .item
            span Глюкоза капиллярной крови
            measure-input( :error="errors.medData.glucose_level_capillary_blood" :name="'Глюкоза капиллярной крови'" :defaultValue="medData.glucose_level_capillary_blood" :measure="'ммоль/л'" :min="0.5" :max="50" :step="0.01" v-model.number="medData.glucose_level_capillary_blood")
          .item
            span Глюкоза венозной крови
            measure-input(:error="errors.medData.glucose_level_venous_blood" :name="'Глюкоза венозной крови'" :defaultValue="medData.glucose_level_venous_blood" :measure="'ммоль/л'" :min="0.5" :max="50" :step="0.01" v-model.number="medData.glucose_level_venous_blood")
          .item
            span Гликированный гемоглобин
            measure-input( :error="errors.medData.a1c_hemoglobin_mass" :name="'Гликированный гемоглобин'" :defaultValue="medData.a1c_hemoglobin_mass" :measure="'мг/л'" :min="1" :max="20" :step="0.01" v-model.number="medData.a1c_hemoglobin_mass")
          .item
            span Микроальбумин в моче
            measure-input( :error="errors.medData.microalbumin_in_urine" :name="'Микроальбумин в моче'" :defaultValue="medData.microalbumin_in_urine" :measure="'мг/сут'" :min="1" :max="1000" :step="0.01" v-model.number="medData.microalbumin_in_urine")
          .item
            span Альбумин в моче
            measure-input( :error="errors.medData.albumin" :name="'Альбумин в моче'" :defaultValue="medData.albumin" :measure="'мг/л'" :min="0" :max="20000" :step="0.01" v-model.number="medData.albumin")
          .item
            span Суточная протеинурия
            measure-input( :error="errors.medData.proteinuria" :name="'Суточная протеинурия'" :defaultValue="medData.proteinuria" :measure="'г/сут'" :min="0" :max="100" :step="0.01" v-model.number="medData.proteinuria")
          .item
            span рН артериальной крови
            measure-input( :error="errors.medData.arterial_blood_ph" :name="'рН артериальной крови'" :defaultValue="medData.arterial_blood_ph" :measure="'рН'" :min="6" :max="8" :step="0.01" v-model.number="medData.arterial_blood_ph")
          .item
            span Натрий крови
            measure-input( :name="'Натрий крови'" :error="errors.medData.sodium_level" :defaultValue="medData.sodium_level" :measure="'ммоль/л'" :min="100" :max="200" :step="0.01" v-model.number="medData.sodium_level")
          .item
            span Гематокрит
            measure-input( :name="'Гематокрит'" :error="errors.medData.hematocrit" :defaultValue="medData.hematocrit" :measure="'%'" :min="5" :max="90" :step="0.01" v-model.number="medData.hematocrit")
          .item
            span PaO<sub>2</sub>
            measure-input(:name="'PaO<sub>2</sub>'" :error="errors.medData.pao2" :defaultValue="medData.pao2" :measure="'мм рт.ст'" :min="10" :max="250" :step="0.01" v-model.number="medData.pao2")
          .item
            span SpO<sub>2</sub>
            measure-input( :name="'SpO<sub>2</sub>'" :error="errors.medData.spo2" :defaultValue="medData.spo2" :measure="'%'" :min="20" :max="100" :step="0.01" v-model.number="medData.spo2")
          .item
            span Альбумин плазмы крови
            measure-input( :name="'Альбумин плазмы крови'" :error="errors.medData.blood_plasma_albumin" :defaultValue="medData.blood_plasma_albumin" :measure="'г/л'" :min="1" :max="100" :step="0.01" v-model.number="medData.blood_plasma_albumin")
          .item
            span Атеросклеротический стеноз любой артерии
            measure-input( :name="'Атеросклеротический стеноз любой артерии'" :error="errors.medData.stenosis_percent" :defaultValue="medData.stenosis_percent" :measure="'%'" :min="1" :max="99" :step="0.01" v-model.number="medData.stenosis_percent")
          .item
            span Фракция выброса левого желудочка
            measure-input( :name="'Фракция выброса левого желудочка'" :error="errors.medData.lv_ejection_fraction" :defaultValue="medData.lv_ejection_fraction" :measure="'%'" :min="10" :max="99" :step="0.01" v-model.number="medData.lv_ejection_fraction")
          .item
            span Атеросклеротические бляшки в аорте
            .radioBtn
              measure-radio-button(:options="checkboxData" :defaultValue="medData.aorta_atherosclerotic_plaques" :name="'aorta_atherosclerotic_plaques'" v-model="medData.aorta_atherosclerotic_plaques")
          .item
            span.longName Мультилобарная инфильтрация (рентгенограмма легких)
            .radioBtn
              measure-radio-button(:options="checkboxData" :defaultValue="medData.is_multilobar_infiltration" :name="'is_multilobar_infiltration'" v-model.number="medData.is_multilobar_infiltration")
        .header_text Анамнез
        .item_block
          .item
            span Табакокурение
            .radioBtn
              measure-radio-button(:options="checkboxData" :defaultValue="medData.is_smoking" :name="'is_smoking'" v-model="medData.is_smoking")
          .item
            span.longName Отягощенная наследственность по инфаркту миокарда<br/>в возрасте до 60 лет у ближайших родственников
            .radioBtn
              measure-radio-button(:options="checkboxData" :defaultValue="medData.is_hereditary_tainted" :name ="'is_hereditary_tainted'" v-model="medData.is_hereditary_tainted" )
          .item
            span Антигипертензивная терапия
            .radioBtn
              measure-radio-button(:options="checkboxData" :defaultValue="medData.is_hypertension_treatment" :name ="'is_hypertension_treatment'" v-model="medData.is_hypertension_treatment" )
          .item
            span Семейная гиперлипидемия
            .radioBtn
              measure-radio-button(:options="checkboxData" :defaultValue="medData.is_family_hyperlipidemia" :name ="'is_family_hyperlipidemia'" v-model="medData.is_family_hyperlipidemia")
          .item
            span Нарушение сознания
            .radioBtn
              measure-radio-button(:options="checkboxData" :defaultValue="medData.is_consciousness_impairment" :name ="'is_consciousness_impairment'" v-model="medData.is_consciousness_impairment")
          .item
            span Пребывания в домах престарелых
            .radioBtn
              measure-radio-button(:options="checkboxData" :defaultValue="medData.is_nursing_home_stay" :name ="'is_nursing_home_stay'" v-model="medData.is_nursing_home_stay" )
        .diagnosis_block
          .item
            span Имеющиеся диагнозы заболеваний
            .diagnosis
              diagnosis-field(v-model="medData.lod" :errors="errors.medData.lod")
        .header_text Случай текущего лечения
        .diagnosis_block
          .item
            span Диагнозы случая текущего лечения
            .diagnosis
              diagnosis-field(v-model="medData.opened_case.diagnoses" :errors="errors.medData.opened_case.diagnoses")
            .datepicker_opened_case(v-if="medData.opened_case.diagnoses.length")
              .datepicker_header Дата открытия случая &nbsp;
                flat-pickr(v-mask="'##.##.####'" title="При ручном вводе данные нужно вводить только через точку" :config="dateConfig" v-model="medData.opened_case.opened_date" placeholder="дд.мм.гггг")
        .diagnosis_block
          .item
            span Дополнительные признаки
            .diagnosis
              analysis-field(v-model="medData.sc" :errors="errors.medData.sc")
        .hint(v-if="Object.keys(validation).length")
          .header Следующие значения указаны некорректно:
          .items
            div(v-for="item in validation")
              span
              li(v-html="item")
        .send_data(style="text-align:center")
          //- button.submitBtn(@click="onSubmit")
          button.submitBtn(@click="onSubmit" :disabled="Object.keys(validation).length > 0")
            div(v-if="showSendingData")
              v-icon(name="spinner" spin scale="1.2" style="color: white; margin-right: 5px")
              br
              span Не обновляйте страницу, при обновлении часть данных будет утеряна
            div(v-if="!showSendingData")
              span Отправить на оценку
        //- br
        //- div(style="text-align: center") {{typeof null}}
    the-footing
    div(:class="{'panding_window_inactive': !showSendingData, 'panding_window_active': showSendingData }")
</template>

<script>
import axios from 'axios'
import TheHeading from '@/components/parts/TheHeading'
import TheFooting from '@/components/parts/TheFooting'
import DiagnosisField from '../fields/DiagnosisField'
import AnalysisField from '../fields/AnalysisField'
import MeasureInput from '../fields/MeasureInput'
import InputAD from '../parts/InputAD'
import MeasureRadioButton from '../fields/MeasureRadioButton'
import flatPickr from 'vue-flatpickr-component'
import { Russian } from 'flatpickr/dist/l10n/ru.js'
import 'flatpickr/dist/flatpickr.css'
import Icon from 'vue-awesome/components/Icon'
import { mask } from 'vue-the-mask'
import genderData from '../../data/labels/gender'
import checkboxData from '../../data/labels/yes_no'
import medicalСareСonditionData from '../../data/labels/medical_care'

export default {
  components: {
    TheHeading,
    TheFooting,
    AnalysisField,
    DiagnosisField,
    MeasureInput,
    InputAD,
    MeasureRadioButton,
    flatPickr,
    'v-icon': Icon
  },
  directives: { mask },
  created () {
    this.$store.state.validateForm.errors = []
    const form = this.$store.state.editForm.form[this.$route.query.savedForm]
    if (form) {
      this.birthdate = this.$moment(form[0].birthdate, 'YYYY.MM.DD').format('DD.MM.YYYY')
      this.gender = form[0].gender
      this.patient_id = form[0].patient_id
      this.medical_care_condition = form[0].medical_care_condition
      this.medData = form[0].medData
      if (form[0].medData.blood_pressure) {
        const [systolicPressure, diastolicPressure] = form[0].medData.blood_pressure.split('/')
        this.medData.systolic_pressure = systolicPressure
        this.medData.diastolic_pressure = diastolicPressure
      }
    }
  },
  data () {
    return {
      // errors: {},
      showSendingData: false,
      toggleData: false,
      caption: 'Анализ данных пациента',
      genderData,
      checkboxData,
      medicalСareСonditionData,
      birthdatePar: false,
      data: {},
      medData: {
        opened_case: {
          diagnoses: []
        }
      },
      errors: {
        birthdate: null,
        medData: {
          opened_case: {
            diagnoses: []
          }
        }
      },
      birthdate: null,
      medical_care_condition: 1,
      gender: 3,
      patient_id: null
    }
  },
  computed: {
    dateConfig () {
      return {
        maxDate: new Date(),
        locale: Russian,
        wrap: true,
        allowInput: true,
        dateFormat: 'd.m.Y'
      }
    },
    validation () {
      return this.$store.state.validateForm.errors || null
    }
  },
  methods: {
    onBlurBirthDate () {
      if (!this.birthdate) {
        this.errors.birthdate = 'Обязательное поле '
        this.$store.dispatch('pushError', 'Дата рождения')
      } else if (
        (this.birthdate && this.birthdate.length < 10) ||
        this.birthdate.length > 10
      ) {
        this.errors.birthdate =
          'Дата должна быть в диапазоне от 01.01.1900 до ' + this.$moment(new Date()).format('DD.MM.YYYY')
        this.$store.dispatch('pushError', 'Дата рождения')
      } else {
        this.errors.birthdate = null
        this.$store.dispatch('deleteError', 'Дата рождения')
      }
    },
    onSubmit () {
      if (this.errors.medData.lod) this.errors.medData.lod = []
      if (this.errors.medData.opened_case) this.errors.medData.opened_case = {}
      let newObj = JSON.parse(JSON.stringify(this.medData))

      this.showSendingData = true // will execute modal window during sending data
      this.data = {} // object to be sent
      this.data.medical_data = {} // same as medData object
      // copy values
      this.data.type_of_information_system = 2
      this.data.result_content = 2
      if (this.birthdate) {
        this.data.birthdate = this.$moment(this.birthdate, 'DD.MM.YYYY').format(
          'YYYY-MM-DD'
        )
        this.birthdatePar = true
      }
      this.data.gender = this.gender
      this.data.patient_id = this.patient_id
      // PARSING ALL DATES TO THE NEEDED FORMAT: (YYYY-MM-DD)
      for (let key in this.medData) {
        if (key === 'opened_case') {
          this.data.medical_data[key] = this.medData[key]
          for (let item in this.medData[key]) {
            if (item === 'opened_date') {
              this.medData[key][item] = this.formatDate(this.medData[key][item], this.data.medical_data[key][item], true)
            }
            if (item === 'diagnoses') {
              for (let diag in this.medData[key][item]) {
                if (this.medData[key][item][diag].date) {
                  this.medData[key][item][diag].date = this.formatDate(this.medData[key][item][diag].date, this.data.medical_data[key][item][diag])
                } else {
                  this.medData[key][item][diag].date = undefined
                }
              }
            }
          }
        } else if (key === 'lod') {
          this.data.medical_data[key] = this.medData[key]
          for (let diag in this.medData[key]) {
            if (this.medData[key][diag].date) {
              this.medData[key][diag].date = this.formatDate(this.medData[key][diag].date, this.data.medical_data[key][diag])
            } else {
              this.medData[key][diag].date = undefined
            }
          }
        } else {
          this.data.medical_data[key] = []
          this.data.medical_data[key].push({
            value: this.medData[key],
            date: this.$moment().format('YYYY-MM-DD')
          })
        }
      }
      if (this.medData && this.medData.sc) {
        console.log('sc', this.medData.sc)
        for (let index in this.medData.sc) {
          if (this.medData.sc[index].value) {
            if (!this.data.medical_data[this.medData.sc[index].code]) {
              this.data.medical_data[this.medData.sc[index].code] = []
            }
            this.data.medical_data[this.medData.sc[index].code].push({
              value: this.medData.sc[index].value,
              date: this.medData.sc[index].date ? this.$moment(this.medData.sc[index].date, 'DD.MM.YYYY').format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD')
            })
          }
          delete this.medData.sc[index]
        }
        delete this.medData.sc
      }
      delete this.data.medical_data.sc
      if (this.data.medical_data) {
        for (let key in this.data.medical_data) {
          if (key !== 'opened_case' && key !== 'lod') {
            for (let index in this.data.medical_data[key]) {
              if (this.data.medical_data[key][index].value === null) {
                delete this.data.medical_data[key]
              }
            }
          }
        }
      }


      // SENDING DATA TO THE SERVER
      axios.post('dhra/api/v2/webiomedmpi/requests/', this.data).then(
        response => {
          let id = response.data.id
          if (this.validation.length) {
            setTimeout(() => {
              this.showSendingData = false
            }, 1000)
          } else {
            this.$router.push({
              name: 'AnalysisSummary',
              params: { id },
              query: {
                t: this.$route.query.t,
                e: true
              }
            })
          }
          this.$store.dispatch('deleteForm')
        },
        error => {
          let e
          if (error.response) e = error.response.data
          for (let key in e) {
            if (key === 'medical_data') {
              for (let innerKey in e[key]) {
                if (innerKey === 'opened_case') {
                  this.errors.medData[innerKey] = e[key][innerKey]
                } else if (innerKey === 'lod') {
                  this.errors.medData[innerKey] = e[key][innerKey]
                } else {
                  this.errors.medData[innerKey] = e[key][innerKey][0].value[0]
                }
              }
            } else this.errors[key] = e[key][0]
          }
          this.medData = JSON.parse(JSON.stringify(newObj))
          this.$notify({
            text: 'Данные введены некорректно',
            type: 'warn'
          })
          setTimeout(() => {
            this.showSendingData = false
          }, 1000)
        }
      )
    },
    formatDate (inDate, outDate, type = false) {
      if (!inDate.length) inDate = undefined
      if (inDate) {
        let bufferOUT = outDate
        let bufferIN = inDate
        if (type) {
          bufferOUT = this.$moment(bufferOUT, 'DD.MM.YYYY').format('YYYY-MM-DD HH:mm:ss')
          outDate = bufferOUT
          if (!this.birthdatePar) inDate = bufferIN
          else inDate = bufferOUT
        } else {
          bufferOUT.date = this.$moment(bufferOUT.date, 'DD.MM.YYYY').format('YYYY-MM-DD')
          outDate.date = bufferOUT.date
          if (!this.birthdatePar) inDate = bufferIN
          else inDate = bufferOUT.date
        }
      }
      return inDate
    }
  }
}
</script>

<style lang="sass" scoped>
.container
  color: #212121
  background: #f7f7f0
  display: flex
  justify-content: center
.main_block
  background: white
  width: 1400px
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2)
  margin-bottom: 40px
  padding-bottom: 60px
.caption
  margin-top: 100px
  margin-left: 20px
.header_text
  color: black
  text-align: center
  font-size: 22px
  margin-top: 40px
.diagnosis_block
  margin-top: 50px
  display: grid
  grid-template-columns:  1fr
  justify-content: center
  padding: 0 20px
.diagnosis
  margin-top: 20px
.item_block
  margin-top: 50px
  display: grid
  grid-template-columns:  1fr 1fr 1fr
  grid-column-gap: 20px
  justify-content: center
  padding: 0 20px
.item
  border: #ebf7f9 2px solid
  min-height: 80px
  border-radius: 10px
  position: relative
  margin-bottom: 40px
.item span
  font-size: 17px
  padding: 0 3px
  display: inline-block
  margin-left: 10px
  margin-top: -10px
  margin-bottom: 5px
  background: white
  position: absolute
.item .longName
  font-size: 15px
  display: flex
  justify-content: space-around
  white-space: pre
.datepicker
  margin: 22px 20px 0 20px
  display: grid
  grid-template-columns: 65% auto 10%
.datepicker input
  border-radius: 4px 0px 0px 4px
  height: 30px
  border: 1px solid #ccc
  font-size: 15px
  color: #212121
  padding-left: 7px
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s
  outline: none
.datepicker input:focus
  border-radius: 4px 4px 4px 4px
  border-color: rgba(26, 163, 255, 0.8)
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(0, 153, 255, 0.6)
.datepicker_opened_case
  margin: 0 20px 40px 20px
  display: inline-block
.datepicker_opened_case input
  border-radius: 2px
  height: 30px
  width: 140px
  border: 1px solid #ccc
  font-size: 15px
  color: #212121
  padding-left: 7px
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s
  outline: none
.datepicker_opened_case input:focus
  border-radius: 4px 4px 4px 4px
  border-color: rgba(26, 163, 255, 0.8)
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(0, 153, 255, 0.6)
.datepicker_opened_case .datepicker_header
  grid-column: 1 / 4
  margin-bottom: 10px
  font-weight: 450
.open
  border: 1px solid #ccc
  background: white
  cursor: pointer
  border-left: none
.clear
  border-radius: 0px 4px 4px 0px
  border: 1px solid #ccc
  border-left: none
  background: white
  cursor: pointer
.clear:hover
  transition: all, .3s
  color: #e2211d
  font-weight: bold
.error
  grid-column: 1 / 4
  color: #e53935
  margin-top: 4px
  margin-bottom: 4px
  font-size: 15px
.radioBtn
  padding: 29px 20px 0 20px
.radioBtn .container
    width: auto
    position: relative
    padding: 2px 0 6px 40px
    cursor: pointer
    font-size: 17px

.i
  color: #212121
.hint
  margin-top: 40px
  display: grid
  justify-content: center
.hint .header
  color: #e53935
  font-size: 17px
  font-weight: 450
.hint .items
  border: 1px solid #e53935
  border-radius: 4px
  padding: 10px
  margin-top: 15px
  background: #fce9e8
  color: #b51a17
  text-align: center
.send_data
  text-align: center
.submitBtn
  position: relative
  z-index: 15
  margin-top: 50px
  padding: 20px 18px
  background: #2793a7
  color: white
  font-family: 'Roboto', Helvetica, Arial, sans-serif
  font-size: 17px
  border: none
  border-radius: 50px
  cursor: pointer
.submitBtn:hover
  transition: all, 0.3s
  background: #1d6c7a
.submitBtn:disabled
  cursor: not-allowed
  background: #1d6c7a
  opacity: .65
  color: #fff
  transition: all, 0.3s
.alert
  font-size: 17px
  color: #e53935
  margin-top: 15px

.panding_window_inactive
  display: none
.panding_window_active
  position: fixed
  top: 0
  right: 0
  left: 0
  opacity: 0.85
  height: 100%
  z-index: 2
  float: bottom
  background: black
  backdrop-filter: blur(8px)
// MEDIA QUERIES
@media screen and (max-width: 1345px)
  .item_block
    grid-template-columns: 1fr 1fr
@media screen and (max-width: 945px)
  .item .longName
  font-size: 14px
@media screen and (max-width: 910px)
  .item_block
    grid-template-columns: 1fr
  .item .longName
  font-size: 15px
</style>
